<!-- This card is only for uploading tool images, not other image content -->
<template>
  <v-card color="primary" class="ma-auto" outlined max-width="500" v-if="isReady">
    <v-card-title class="white--text"
      >Signup for {{ activeEvent.name }}<v-spacer />
      <v-btn
        class="mx-2"
        text
        fab
        dark
        small
        @click.stop="showHelp()"
        v-if="!$vuetify.breakpoint.mdAndUp"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-card-title>
    <input
      v-if="!noMoreChanges"
      type="file"
      ref="imagefile"
      style="display: none"
      accept="image/*"
      :capture="captureType"
      @change="uploadPhoto($event)"
    />
    <!-- BODY STARTS HERE -->
    <v-list class="py-0">
      <!-- Part 1.1 - Main Data: Kerberos -->
      <v-list-item class="pt-2">
        <v-list-item-icon>
          <v-icon> mdi-information-outline</v-icon>
        </v-list-item-icon>
        {{ activeEvent.description }}
      </v-list-item>
      <v-list-item>
        <v-switch
          class="pb-2"
          v-model="onlyShowAvailable"
          label="only show available sign-up slots"
          color="secondary"
          hide-details
        ></v-switch>
      </v-list-item>
    </v-list>
    <v-divider />    
    <v-list dense two-line>
      <v-list-item-group v-model="selection" active-class="">
        <v-list-item
          v-for="entry in sessionsToShow"
          :key="entry.id"
          :value="entry.id"
          :disabled="!hasCapacity(entry) || isPastDeadline(entry) || noMoreChanges"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-checkbox
                :input-value="active"
                v-if="
                  (hasCapacity(entry) && !isPastDeadline(entry) && !noMoreChanges) ||
                  isMySignUp(entry)
                "
              ></v-checkbox>
              <v-icon v-else>mdi-cancel</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title v-if="isPastDeadline(entry)">
                {{ entry.name }} -
                <span v-if="isMySignUp(entry)">
                  - Currently signed up (past deadline for changes)</span
                >
                <span v-else>Past the sign-up deadline.</span>
              </v-list-item-title>
              <v-list-item-title v-if="!isPastDeadline(entry) && noMoreChanges">
                {{ entry.name }} - Past deadline for changes
              </v-list-item-title>
              <v-list-item-title v-if="!isPastDeadline(entry) && !noMoreChanges"
                >{{ entry.name }} ({{ getCapacity(entry) }} available)<span
                  v-if="isMySignUp(entry)"
                >
                  - Currently signed up</span
                ><span v-if="!hasCapacity(entry)"> -- Session is full</span>
              </v-list-item-title>
              <v-list-item-subtitle>{{ getStartTime(entry) }} </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-divider />
    <v-layout justify-center align-center class="blue-grey lighten-3">
      <v-flex shrink>
        <v-progress-linear
          indeterminate
          color="blue-grey accent-1"
          height="6"
          v-if="isSaving"
        ></v-progress-linear>
        <v-img
          :src="resultImage"
          :width="targetWidth"
          :height="targetHeight"
          :contain="true"
          class="blue-grey lighten-5"
          @click="addImageFromFile"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
              v-if="
                resultImage == '' || resultImage == undefined || isNotRegistered == true
              "
            >
              <v-icon x-large color="primary" class="ma-5">mdi-cloud-upload</v-icon>
              Upload a photo
            </v-row>
            <v-row class="fill-height ma-0" align="center" justify="center" v-else>
              <v-progress-circular
                :size="30"
                :width="7"
                color="primary"
                class="mr-5"
                indeterminate
              ></v-progress-circular>
              Loading...
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-list>
      <v-list-item>
        <v-text-field
          ref="message"
          v-model="message"
          :rules="[
            () =>
              (!!message && message.length <= 30) ||
              'Caption must be less than 30 characters',
          ]"
          label="Image Caption / Message"
          placeholder="Enter a short message to print along with your image"
          counter="30"
        ></v-text-field>
      </v-list-item>
      <v-list-item class="py-2" dense>
        <v-list-item-content>
          <v-list-item-subtitle class="text-wrap">
            Note: the chip is 2x2cm. Your photo will be sized to fit. We recommend a
            square'ish image, to avoid empty bands. Image resolution should be more than
            500 pixels. We print 1000 pixels, images larger will be downsampled (so no
            need to upload a 4000 pixel image...)
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider />
    <v-list>
      <v-list-item v-if="enableCancelButton">
        <v-btn color="primary" large class="mr-3" @click="cancelReservation">
          <v-icon class="mr-2">mdi-cancel</v-icon> Delete my Signup
        </v-btn>
      </v-list-item>
      <v-list-item v-if="enableCancelButton">
        If you no longer can attend, you can delete your sign up here. You can always sign
        up again for an available slot later.
      </v-list-item>
      <v-list-item class="py-2" v-if="!noMoreChanges && !enableCancelButton">
        <v-btn
          color="secondary"
          large
          class="mr-3"
          :disabled="!enableSaveButton || isSaving"
          @click="sendSignup"
        >
          <v-icon class="mr-2">mdi-send</v-icon> Submit
        </v-btn>
        <span v-if="!enableSaveButton && !existingImageURL"
          >Please attach the image you like to add, and select a timeslot</span
        >
        <span v-if="!enableSaveButton && existingImageURL"
          >You can modify the image, or select a different timeslot</span
        >
      </v-list-item>
      <v-list-item v-if="noMoreChanges">
        You are signed up for the above session. It's past the deadline to make any
        changes (or move sessions).
      </v-list-item>
    </v-list>
  </v-card>

  <v-card color="primary" class="ma-auto" outlined max-width="500" v-else>
    <v-card-title class="white--text"
      >Loading data<v-spacer />
      <v-btn
        class="mx-2"
        text
        fab
        dark
        small
        @click.stop="showHelp()"
        v-if="!$vuetify.breakpoint.mdAndUp"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-list>
      <v-list-item>
        <v-progress-circular
          :size="40"
          :width="7"
          color="secondary"
          class="mr-5"
          indeterminate
        ></v-progress-circular>
        Please wait a second or two...
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import HelpDialog from "@/support/helpMessage";
import dataloader from "@/api/dataloader.js";
import moment from "moment";
var FormData = require("form-data");

export default {
  data: () => ({
    kerberos: "",
    eventname: "iap",
    message: "",
    sessions: [],
    selection: undefined,
    targetWidth: 200,
    targetHeight: 200,
    isSaving: false,
    myImage: "",
    resultImage: "",
    captureType: false,
    ImagePrefixString: "data:image/jpg;base64,",
    onlyShowAvailable: false,
    submitCounter: 0,
  }),
  props: {
    viewoption: {
      type: String,
      required: false,
      default: "normal",
    },
  },
  watch: {
    username(newName) {
      if (this.kerberos !== newName) this.kerberos = newName;
    },
    imageMessage(newMessage) {
        this.message = newMessage;
    },
    sessionsToShow() {
      if (this.selection == undefined)
        this.selection = this.sessionsToShow.findIndex(
          (el) => el.id == this.registeredSession[0]
        );
    },
    existingImageURL() {
      if (this.existingImageURL !== undefined) {
        if (this.myImage) window.URL.revokeObjectURL(this.myImage);
        this.resultImage = this.existingImageURL;
      }
    },
    activeEvent(newEvent) {
      if (newEvent.sessions == undefined) return;
      this.sessions = JSON.parse(JSON.stringify(newEvent.sessions));
      this.selection = this.registeredSession[0];
      if (this.mySession == undefined) this.onlyShowAvailable = true;
    },
  },

  computed: {
    isReady() {
      /**
       * check that data has been returned from the API
       */
      if (this.username == undefined) return false;
      return !this.$store.getters.isLoading;
    },
    userdata() {
      return this.$store.getters.getUserdata;
    },
    imageMessage() {
      return this.userdata.message;
    },
    events() {
      return this.$store.getters.getEventList;
    },
    activeEvent() {
      if (this.events == undefined || this.events[this.eventname] == undefined)
        return { name: "Loading...", description: "Loading..." };
      return this.events[this.eventname];
    },
    username() {
      return this.userdata.username;
    },
    email() {
      return this.userdata.username + "@mit.edu";
    },
    registeredSession() {
      if (this.userdata.events == undefined) return [];
      if (this.userdata.events[this.eventname] == undefined) return [];
      return this.userdata.events[this.eventname];
    },
    mySession() {
      let regSession = this.registeredSession;
      let myEvent = this.activeEvent;
      if (myEvent.sessions == undefined) return undefined;
      return myEvent.sessions.find((el) => regSession.includes(el.id));
    },
    isNotRegistered() {
      var mysession = this.registeredSession;
      if (mysession[0] < 0) return true;
      return false;
    },
    getSelectedSession() {
      // returns the sessions entry that matches current selection
      if (this.selection == undefined) return undefined;
      return this.sessionsToShow.find((el) => el.id == this.selection);
    },
    hasSelectedNewSession() {
      // return true if the new selection differs from signup
      if (this.mySession == undefined) {
        return this.selection !== undefined;
      }
      return this.selection != this.mySession.id;
    },
    enableCancelButton() {
      // show cancel option if signed up for something, but no slot selected
      if (this.mySession == undefined) return false;
      return this.selection == undefined;
    },
    enableSaveButton() {
      // can save if there's a new selection, a new image, or a new signup with both selection & image
      if (this.mySession == undefined) {
        // new person first time signup, require both
        return this.myImage !== "" && this.selection != undefined;
      }
      // existing person: one must have changed
      if (this.myImage !== "") return true;
      if (this.imageMessage != this.message) return true;
      return this.hasSelectedNewSession;
    },
    noMoreChanges() {
      // check if past deadline and registered (not edits or cancellations)
      let checkThis = this.mySession;
      if (checkThis == undefined) return false;
      return this.isPastDeadline(checkThis);
    },

    sessionsToShow() {
      let result = this.sessions;
      // remove past sessions
      result = result.filter((el) => {
        if (this.isMySignUp(el)) return true;
        if (this.isHistory(el)) return false;
        return true;
      });
      // remove unavailable sessions
      if (this.onlyShowAvailable == true) {
        result = result.filter((el) => {
          if (this.isMySignUp(el)) return true;
          if (this.noMoreChanges) return false;
          if (this.isPastDeadline(el)) return false;
          if (this.hasCapacity(el)) return true;
          return false;
        });
      }
      return result;
    },
    existingImageURL() {
      if (this.userdata.content == undefined) return undefined;
      if (this.userdata.content[this.eventname] == undefined) return undefined;
      if (this.isNotRegistered) return "";
      return this.userdata.content[this.eventname] + this.submitCounter;
    },
  },

  methods: {
    getStartTime(entry) {
      return moment(entry.start, "MM/DD/YYYY hh:mma").format(
        "ddd, MMM DD, YYYY @ hh:mma"
      );
    },
    isMySignUp(entry) {
      let regSession = this.registeredSession;
      return regSession.includes(entry.id);
    },
    getCapacity(entry) {
      if (entry.current == undefined) entry.current = 0;
      let capacity = entry.capacity - entry.current;
      if (this.isMySignUp(entry)) {
        capacity = capacity + 1;
      }
      return capacity;
    },
    hasCapacity(entry) {
      return this.getCapacity(entry) > 0;
    },
    isHistory(entry) {
      try {
        var eventStart = moment(entry.start, "MM/DD/YYYY hh:mma").valueOf();
        return eventStart < moment().valueOf();
      } catch (ex) {
        console.log(ex);
        return false;
      }
    },
    isPastDeadline(entry) {
      try {
        var eventStart = moment(entry.start, "MM/DD/YYYY hh:mma").valueOf();
        let myEvent = this.activeEvent;
        if (myEvent == undefined || myEvent.deadline == undefined)
          return moment().valueOf() >= eventStart;
        return (
          moment().add(myEvent.deadline.value, myEvent.deadline.units).valueOf() >=
          eventStart
        );
      } catch (ex) {
        console.log(ex);
        return false;
      }
    },
    isHex(s) {
      if (s == undefined) return undefined;
      var sHex = s.replace(/[^a-fA-F0-9]/g, "");
      return sHex == s;
    },
    async showHelp() {
      const aMessage = HelpDialog.GetHelpMessage();
      await this.$root.$confirmdialog("About - Fab.nano Signup", aMessage, {
        color: "secondary",
        reject: "",
        accept: "Okay",
      });
    },
    async showError(message) {
      const aMessage = HelpDialog.GetErrorMessage(message);
      await this.$root.$confirmdialog("About - Fab.nano Signup", aMessage, {
        color: "secondary",
        reject: "",
        accept: "Okay",
      });
    },
    async readImageURL(file) {
      const ext = (file.name
        ? file.name.split(".").pop()
        : file.path.split(".").pop()
      ).toLowerCase();
      // If heic or heif, convert to jpeg
      if (ext === "heic" || ext === "heif") {
        const heic2any = (await import("heic2any")).default;
        const outputBlob = await heic2any({
          blob: file, // Use the original file object
          toType: "image/jpeg",
          quality: 0.8, // adjust quality as needed
        });
        return window.URL.createObjectURL(outputBlob);
      } else {
        return window.URL.createObjectURL(file);
      }
    },

    async uploadImage() {
      if (this.isSaving) return;
      try {
        this.isSaving = true;
        // upload the images
        // prepare request parameters
        var formData = new FormData();
        if (this.myImage !== undefined) {
          if (this.myImage !== "") {
            console.log("attaching raw image");
            await formData.append(
              "image",
              await fetch(this.myImage).then((r) => r.blob()),
              "image"
            );
          }
        }
        formData.append("kerberos", this.userdata.username);
        formData.append("eventname", this.eventname);
        formData.append("session", this.selection);
        formData.append("message", this.message);
        var result = await dataloader.sendDataForUpload(this.eventname, formData);
        this.isSaving = false;
        if (result.error) {
          await this.showUploadError();
        } else {
          this.$router.replace("/done");
        }
      } catch (ex) {
        console.log(ex);
        this.isSaving = false;
        await this.showUploadError();
      }
    },

    addImageFromCamera() {
      this.captureType = "camera";
      this.$nextTick(() => {
        this.$refs.imagefile.click();
      });
    },
    addImageFromFile() {
      this.captureType = false;
      this.$nextTick(() => {
        this.$refs.imagefile.click();
      });
    },

    async uploadPhoto(evt) {
      if (evt.target.files.length !== 0) {
        if (this.myImage) window.URL.revokeObjectURL(this.myImage);

        this.myImage = await this.readImageURL(evt.target.files[0]);
        //this.myImage = window.URL.createObjectURL(evt.target.files[0]);
        this.resultImage = this.myImage;
      }
    },
    async cancelReservation() {
      await dataloader.sendCancellation(this.eventname);
      this.$store.dispatch("getData");
      this.submitCounter++; // and make sure image updates
      this.resultImage = "";
    },
    async sendSignup() {
      await this.uploadImage();
      // refresh data
      this.$store.dispatch("getData");
      this.submitCounter++; // and make sure image updates
    },
  },

  mounted() {
    console.log("mounted select");
    this.kerberos = this.username;
    if (this.activeEvent.sessions == undefined) return false;
    this.sessions = JSON.parse(JSON.stringify(this.activeEvent.sessions));
    this.selection = this.registeredSession[0];
    this.message = this.imageMessage
    if (this.existingImageURL !== undefined) {
      if (this.myImage) window.URL.revokeObjectURL(this.myImage);
      this.resultImage = this.existingImageURL;
    }
  },
};
</script>
